import { alpha } from '@mui/material/styles'
import theme from '../base'

const tabs = {
  MuiTabs: {
    styleOverrides: {
      root: {
        borderBottom: `1px solid ${alpha(theme.palette.neutral.lighter, 0.4)}`,
        [theme.breakpoints.down('sm')]: {
          overflow: 'initial',
          position: 'sticky',
          top: 64,
          zIndex: 2,
          backgroundColor: theme.palette.neutral.white,
        },
      },
      indicator: {
        borderRadius: 2,
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        maxWidth: 'none',
        ...theme.typography.h3,
        textTransform: 'none',
        '&.MuiTab-textColorPrimary': {
          color: theme.palette.neutral.light,
          '&:hover, &.Mui-selected': {
            color: theme.palette.neutral.dark,
          },
        },
        [theme.breakpoints.up('sm')]: {
          minWidth: 0,
          padding: theme.spacing(1, 3),
        },
      },
    },
  },
  MuiTabPanel: {
    styleOverrides: {
      root: {
        padding: 0,
        [theme.breakpoints.up('sm')]: {
          padding: theme.spacing(4, 0, 2),
        },
      },
    },
  },
}

export default tabs
